import { createContext, RefObject } from 'react'

interface AdminContextType {
  menuRef: RefObject<HTMLElement> | null
  setMenuRef: (ref: RefObject<HTMLElement>) => void
}

export const AdminContext = createContext<AdminContextType>({
  menuRef: null,
  setMenuRef: function (ref) {
    this.menuRef = ref
  },
})
